export const ApprovalTypes = {
  APPROVAL_SET_ALL: 'APPROVAL_SET_ALL',
  ADD_APPROVAL_OBSERVATION: 'ADD_APPROVAL_OBSERVATION',
  REMOVE_APPROVAL_OBSERVATION: 'REMOVE_APPROVAL_OBSERVATION',
}
